import { queryOptions } from '@tanstack/react-query';
import { bankQueryRoot } from '../../../../shared/api/index.js';
import { getPaymentBankLinks } from '../requests/get-payment-bank-links.js';

export const bankMatchQueries = {
  all: () => [...bankQueryRoot.all(), 'matches'] as const,
  paymentLinks: (paymentId: string) =>
    queryOptions({
      queryKey: [...bankMatchQueries.all(), 'payment-links', paymentId] as const,
      queryFn: ({ signal }) => getPaymentBankLinks(paymentId, signal),
    }),
};
